// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__15z0q","description":"PatientConsentPreview_description__B5E6w"};